// Built-in chat background filenames located under public/images/chat_background
// Keep this list in sync with files in that folder.
export const CHAT_BACKGROUND_FILES = [
  'Elven_Forest.jpg',
  'Inn.jpg',
  'Open_Sea.jpg',
  'Pirates.jpg',
  'Cthulu.jpg',
  'Forest_Arc.jpg'
]

// Optional: path prefix for public assets (root-relative)
// Resolves to '/images/chat_background' regardless of current route
export const CHAT_BACKGROUND_PUBLIC_PATH = '/assets/images/chat_background'
